export default __webpack_public_path__ + "assets/5c1a522e4e0010052c793cd77555646a.png";